import React from 'react';
import Student1 from '@assets/images/person.png' ;
const AlumniSpeak = () => {
    // JSON data for the component
    const heroData = {
        title: "yslearn Reviews: Real Stories, Incredible Journeys",
        description:
            "Read unfiltered reviews from students who have taken our courses— from AI newbies to digital marketing experts, our diverse portfolio has empowered professionals across the globe to unlock their full potential and achieve their career aspirations.",
        buttonText: "View Success Stories"
    };

    const statsData = [
        {
            number: "5 Million+",
            label: "Careers Advanced",
            icon: "👥"
        },
        {
            number: "85%",
            label: "Report Career Impact",
            icon: "📈"
        },
        {
            number: "100+",
            label: "Career Options to Choose From",
            icon: "🎯"
        }
    ];

    const alumniData = [
        {
            id: 1,
            name: "Siddharth Sinha",
            image: Student1,
            currentRole: "Senior Electrical Engineer",
            currentCompany: "Acuity Brands",
            previousRole: "Sr Field Applications Engineer",
            previousCompany: "Samsung",
            companyLogos: {
                current: "🔌",
                previous: "📱"
            }
        },
        {
            id: 2,
            name: "Roshini Sharma",
            image: Student1,
            currentRole: "Senior UX/UI Designer",
            currentCompany: "Billtrust",
            previousRole: "Senior UX/UI Designer",
            previousCompany: "Billtrust",
            companyLogos: {
                current: "💎",
                previous: "💎"
            }
        },
        {
            id: 3,
            name: "Mithali Sharma",
            image: Student1,
            currentRole: "Senior Account Manager",
            currentCompany: "Amazon",
            previousRole: "Senior Account Manager",
            previousCompany: "Amazon",
            companyLogos: {
                current: "📦",
                previous: "📦"
            }
        }
    ];

    return (
        <div className="max-w-full mx-auto bg-[#f2f5fa]">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6] text-white relative overflow-hidden">
                <div className="!absolute top-0 right-0 w-96 h-96 bg-gradient-to-l from-orange-400 to-yellow-400 rounded-full transform translate-x-32 -translate-y-32 opacity-90"></div>

                <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        {/* Left Content */}
                        <div className="space-y-6">
                            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
                                {heroData.title}
                            </h1>
                            <p className="text-lg md:text-xl text-blue-100 leading-relaxed">
                                {heroData.description}
                            </p>
                            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300 shadow-lg hover:shadow-xl">
                                {heroData.buttonText}
                            </button>
                        </div>

                        {/* Right Content - People Images */}
                        <div className="relative">
                            <div className="flex justify-center items-center space-x-4">
                                <div className="w-full h-full  rounded-full bg-white shadow-lg overflow-hidden">
                                    <img src={Student1} alt="Student 1" className="w-full h-full object-cover"  loading="lazy" />
                                </div>
                                <div className="w-full h-full rounded-full bg-white shadow-lg overflow-hidden transform -translate-y-8">
                                    <img src={Student1} alt="Student 2" className="w-full h-full object-cover"   loading="lazy"/>
                                </div>
                                <div className="w-full h-full rounded-full bg-white shadow-lg overflow-hidden">
                                    <img src={Student1} alt="Student 3" className="w-full h-full object-cover"  loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Stats Section */}
            <div className="bg-white py-16">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
                        Driving Career Impact
                    </h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {statsData.map((stat, index) => (
                            <div key={index} className="text-center p-8 bg-gray-50 rounded-xl hover:shadow-lg transition-shadow duration-300">
                                <div className="text-4xl mb-4">{stat.icon}</div>
                                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
                                    {stat.number}
                                </div>
                                <div className="text-gray-600 font-medium text-lg">
                                    {stat.label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Alumni Stories Section */}
            <div className="bg-[#f2f5fa] py-16">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
                        Careers Impacted, Lives Changed
                    </h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {alumniData.map((alumni) => (
                            <div key={alumni.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
                                {/* Profile Section */}
                                <div className="p-6 text-center">
                                    <div className="w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden shadow-lg">
                                        <img src={alumni.image} alt={alumni.name}   loading="lazy" className="w-full h-full object-cover" />
                                    </div>
                                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                                        {alumni.name}
                                    </h3>
                                </div>

                                {/* Career Journey */}
                                <div className="px-6 pb-6 space-y-4">
                                    {/* Current Role */}
                                    <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                                        <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white text-xl">
                                            {alumni.companyLogos.current}
                                        </div>
                                        <div className="flex-1">
                                            <div className="font-semibold text-gray-800 text-sm">
                                                {alumni.currentRole}
                                            </div>
                                            <div className="text-gray-600 text-sm">
                                                {alumni.currentCompany}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Arrow */}
                                    <div className="flex justify-center">
                                        <div className="text-orange-500 text-2xl">↑</div>
                                    </div>

                                    {/* Previous Role */}
                                    <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                                        <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center text-white text-xl">
                                            {alumni.companyLogos.previous}
                                        </div>
                                        <div className="flex-1">
                                            <div className="font-semibold text-gray-800 text-sm">
                                                {alumni.previousRole}
                                            </div>
                                            <div className="text-gray-600 text-sm">
                                                {alumni.previousCompany}
                                            </div>
                                        </div>
                                    </div>

                                    {/* View Story Button */}
                                    <button className="w-full mt-6 text-blue-600 hover:text-blue-700 font-semibold py-2 text-sm transition-colors duration-300 flex items-center justify-center space-x-2">
                                        <span>View Story</span>
                                        <span>→</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlumniSpeak;